export enum EFolderSystemSpecialUse {
  DRAFTS = '\\Drafts',
  SENT = '\\Sent',
  TRASH = '\\Trash',
  JUNK = '\\Junk',
  INBOX = '\\Inbox'
}

export enum EFolderOptionalSpecialUse {
  ARCHIVE = 'Archive'
}

export type EFolderSpecialUse = EFolderSystemSpecialUse | EFolderOptionalSpecialUse;
